import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { statsApi } from '@/common/services/api'
import { HYDRATE } from 'next-redux-wrapper'
import { createQueryParams } from '@/common/utils/transformFilters'

export const fetchInputHints = createAsyncThunk(
  'filters/fetchInputHints',
  async (_, { rejectWithValue }) => {
    try {
      return await statsApi.getSearchHints()
    } catch (e) {
      const headers = e?.response?.headers ?? {}
      return rejectWithValue(headers)
    }
  }
)

export const changeFilterPinnedStatus = createAsyncThunk(
  'filters/changeFilterPinnedStatus',
  async ({ name, storeName }, { dispatch, getState }) => {
    const filterParams = getState()[storeName].filtersParams

    await dispatch(
      filtersSlice.actions.togglePinnedStatus({
        name,
        isEmpty: !Object.keys(createQueryParams(filterParams[name])).length,
      })
    )
  }
)

export const filtersSlice = createSlice({
  name: 'filters',
  initialState: {
    filtersInputs: [],
    filtersInputsHints: null,
    isLoadingHints: true,
  },
  reducers: {
    addFilters: (state, { payload }) => {
      if (!payload?.name) return
      //TODO DELETE SOON
      if (payload?.name === 'order_by') return

      const findIndex = state.filtersInputs.findIndex(
        (input) => input.name === payload.name
      )

      if (findIndex === -1) {
        state.filtersInputs.push(payload)
        return state
      }

      state.filtersInputs.splice(findIndex, 1, payload)
    },
    removeFilterParam: (state, action) => {
      state.filtersInputs = state.filtersInputs.filter(
        (item) => item.name !== action.payload.name
      )
    },
    clearFilters: (state) => {
      state.filtersInputs = []
    },
    clearFiltersParams: (state) => {
      state.filtersInputs = state.filtersInputs.filter(
        (filter) => filter.pinned
      )
    },
    clearPinnedFilters: (state) => {
      state.filtersInputs = state.filtersInputs.filter(
        (filter) => filter.pinned
      )
    },
    addFiltersInputsHints(state, { payload }) {
      state.filtersInputsHints = payload
    },
    togglePinnedStatus: (state, { payload }) => {
      const findFilterIndex = state.filtersInputs.findIndex(
        (filter) => filter.name === payload.name
      )
      const input = state.filtersInputs[findFilterIndex]

      if (payload.isEmpty && input.pinned) {
        state.filtersInputs = state.filtersInputs.filter(
          (filter) => filter.name !== input.name
        )
        return state
      }

      if (findFilterIndex !== -1) {
        state.filtersInputs.splice(findFilterIndex, 1, {
          ...input,
          pinned: !input.pinned,
        })
      }
    },
  },

  extraReducers: {
    [HYDRATE]: (state, action) => {
      const { filters } = action.payload

      if (!state.filtersInputs.length && filters.filtersInputs.length) {
        state.filtersInputs = filters.filtersInputs
      }
    },
    [fetchInputHints.fulfilled]: (state, { payload }) => {
      state.filtersInputsHints = payload
      state.isLoadingHints = false
    },
    [fetchInputHints.rejected]: (state) => {
      state.isLoadingHints = false
      state.filtersInputsHints = []
    },
  },
})

export const filtersActions = filtersSlice.actions

export default filtersSlice.reducer
